// extracted by mini-css-extract-plugin
module.exports = {"valueSuggestion":"ValueSuggestion_valueSuggestion__3JYpl"};